import React, { useState } from 'react'
import ButtonGroup from '@components/button-group'
import Column from '@components/column'
import ColumnItem from '@components/rebrand/column-item'
import Image from "@components/image"
import { Link } from 'gatsby'
import { getUriFromDocument } from '@utils/routing'

const CollectionListDesktop = ({data, colorSettings }) => {
  const { heading, collections, ctaList, defaultImage } = data
  const [selectedCollection, setSelectedCollection] = useState({
    index: 0,
    title: "",
    image: defaultImage
  });

  const handleMouseEnter = (collection, index) => {
    const imageToSet = collection?.collectionImage ?? collection?.mainImage;
    imageToSet !== null && setSelectedCollection({
      index,
      title: collection?.title,
      image: imageToSet
    });
  };

  return (
    <>
      <Column
        colorSettings={colorSettings}
        className={"max-w-1/3 min-w-fit max-md:hidden"}
      >
        <ColumnItem className={"!gap-y-2.5"}>
          <h2>{heading}</h2>
          <div className="flex flex-col">
            {collections?.map((collection, index) => (
              <div key={index} className="flex py-2.5">
                <Link
                  to={getUriFromDocument(collection)}
                  title={collection?.title}
                  className="subheadline font-normal cursor-pointer hover:text-green-primary transition-colors duration-200"
                  onMouseEnter={() => handleMouseEnter(collection, index)}
                  onFocus={() => handleMouseEnter(collection, index)}
                  onMouseLeave={() => setSelectedCollection({
                    index,
                    title: collection?.title,
                    image: defaultImage
                  })}
                >
                  {collection?.title}
                </Link>
              </div>
            ))}
          </div>
        </ColumnItem>
        <ButtonGroup isFullWidth={false} list={ctaList} />
      </Column>
      <Column
        colorSettings={colorSettings}
        className={"max-w-2/3 !p-0 aspect-[29/23] max-md:hidden"}
        noPadding={true}
      >
        <Image
          image={selectedCollection?.image}
          altPrefix={`Image showcasing the collection ${selectedCollection?.title}:`}
          width={860}
          height={690}
          className={"rounded-xl"}
        />
        {collections?.filter((collection, index) => index !== selectedCollection?.index)?.map((collection) => (
          <Image
            image={collection?.collectionImage ?? collection?.mainImage}
            altPrefix={`Image showcasing the collection ${collection?.title}:`}
            width={860}
            height={690}
            key={Math.random()}
            className={"rounded-xl sr-only"}
          />
        ))}
      </Column>
    </>
  )
}

export default CollectionListDesktop